import React from 'react';
import { usePassword } from './hooks/usePassword';
import { PasswordRequirements } from './PasswordRequirements/PasswordRequirements';
import { PasswordInput } from './PasswordInput/PasswordInput';
import { usePasswordReset } from 'components/newAccountSteps/initialStep/fields/Password/hooks/usePasswordReset';

export const Password = ({
    userProfile,
    userProfileForm,
    resetDependencies,
    formActions,
    setIsValidPass,
    onFocus,
    onObscurePasswordChange,
    onCustomError,
}) => {
    const {
        state: { hasErrors, passAscDesc, passBirthDay, passBirthYear, passEquals },
        handleValidations,
        handleOnChange,
        resetState,
    } = usePassword({
        onCustomError,
        formActions,
        setIsValidPass,
        birthDay: userProfile.birthDay,
        birthMonth: userProfile.birthMonth,
        birthYear: userProfile.birthYear,
    });
    usePasswordReset({ resetState, resetDependencies });

    return (
        <div className="row">
            <PasswordInput
                handleOnChange={handleOnChange}
                handleValidations={handleValidations}
                hasErrors={hasErrors}
                userProfile={userProfile}
                userProfileForm={userProfileForm}
                formActions={formActions}
                onFocus={onFocus}
                onObscurePasswordChange={onObscurePasswordChange}
                resetDependencies={resetDependencies}
            />
            <PasswordRequirements
                hasErrors={hasErrors}
                passAscDesc={passAscDesc}
                passBirthDay={passBirthDay}
                passBirthYear={passBirthYear}
                passEquals={passEquals}
            />
        </div>
    );
};
